import {
  SITE_STATUS_DRAFT_ID,
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
} from 'constants/siteStatuses'
import { INDIVIDUAL_ROLE_ID, NCG_ROLE_ID } from 'constants/roles'

/**
 * Derives the disabled state and edit-only status for SiteProposal flow pages.
 *
 * Centralises the logic that was duplicated verbatim across About and Details:
 *   - editOnlySiteStatus  — true when site is in EDIT_ONLY or SUBMITTED_EDIT_ONLY state
 *   - disabled            — whether form fields should be read-only for the current user
 *
 * @param {object} site       - site object from SiteContext
 * @param {boolean} isEditable - isEditable flag from SiteContext
 * @param {string|number} roleId - current user's RoleId from ProfileContext
 * @returns {{ disabled: boolean, editOnlySiteStatus: boolean }}
 */
export function useSiteEditPermissions({ site, isEditable, roleId }) {
  const editOnlySiteStatus =
    site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID ||
    site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

  const disabledBtn =
    site.SiteStatusId !== SITE_STATUS_DRAFT_ID ||
    (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID)

  const isEditOnlyEnabledBtn =
    (site.SiteStatusId !== SITE_STATUS_DRAFT_ID && site.SiteStatusId !== SITE_STATUS_EDIT_ONLY_ID) ||
    (isEditable && (site.SiteStatusId === SITE_STATUS_DRAFT_ID || site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID)) ||
    (!isEditable &&
      site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID &&
      roleId !== INDIVIDUAL_ROLE_ID &&
      roleId !== NCG_ROLE_ID)

  const disabled = editOnlySiteStatus ? isEditOnlyEnabledBtn : disabledBtn

  return { disabled, editOnlySiteStatus }
}
